import React from 'react';
import { Quote, Play } from 'lucide-react';
import { mockTestimonials } from '../data/mockData';

export default function Testimonials() {
  return (
    <section id="testimonials" className="py-20 px-6 lg:px-[7.69%] border-b border-border-medium bg-bg-primary">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="section-tag">/Client Success</span>
          <h3 className="display-large">What Our Partners Say</h3>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {mockTestimonials.map((item) => (
            <div key={item.id} className="relative group h-[380px] w-full border border-border-medium hover:border-brand-primary overflow-hidden cursor-pointer transition-colors duration-150">
              {/* Background Image */}
              <img 
                src={item.bg} 
                alt="Office Background" 
                className="absolute inset-0 w-full h-full object-cover filter brightness-[0.25] group-hover:brightness-[0.4] transition-all duration-500"
              />
              
              {/* Content Overlay */}
              <div className="absolute inset-0 p-10 flex flex-col justify-between z-10">
                <Quote className="w-12 h-12 text-brand-primary opacity-50" />
                
                <div className="bg-black/60 backdrop-blur-sm p-5 border-l-2 border-brand-primary">
                  <p className="heading-2 italic mb-4 text-text-primary">"{item.quote}"</p>
                  <div>
                    <p className="text-brand-primary font-bold uppercase" style={{ fontSize: '11px', letterSpacing: '1px' }}>{item.name}</p>
                    <p className="text-text-muted" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>{item.role}</p>
                  </div>
                </div>

                {/* Play Button Overlay (Visual Only for MVP) */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-20 h-20 rounded-full border border-white flex items-center justify-center bg-black/50 backdrop-blur-md">
                    <Play className="w-8 h-8 text-white ml-1 fill-white" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
